
import Breadcrumbs from 'library/components/globals/breadcrumbs'

export default

	props: product: Object

	computed:
		vendorLink: ->
			if @product?.vendor
			then "/collections/#{@$slugify(@product.vendor)}"

		links: -> [
			{
				text: "Shop"
				href: "/collections/all"
			}
			{
				text: @product.vendor
				href: @vendorLink
			}
		]

	render: (create, context) ->
		create Breadcrumbs, {
			props:
				links: @links
		}

